import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'formik';
import classnames from 'classnames';
import ConfirmDialog from '../dialogs/ConfirmDialog';

export default connect(function ButtonWithRestoreGroup({
  saveDirty = null,
  formik: {values, isSubmitting},
  submitText,
  cancelText,
  onCancelClick,
  restoreText,
  onRestoreClick,
  isUpdating = false,
  discardButton = true,
  onSubmitFunc = () => {},
}) {
  return (
    <>
      <ConfirmDialog confirmCallback={onRestoreClick}>
        <button
          type="button"
          className="btn btn-outline-danger kt-margin-r-10 kt-margin-b-10"
          disabled={isSubmitting}
        >
          {restoreText || (
            <Trans i18nKey="c.f.simple.button.group.restore">
              Restore Defaults
            </Trans>
          )}
        </button>
      </ConfirmDialog>
      {discardButton && (
        <>
          {' '}
          {onCancelClick ? (
            <button
              type="button"
              className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10"
              disabled={isSubmitting}
              onClick={onCancelClick}
            >
              {cancelText || (
                <Trans i18nKey="c.f.simple.button.group.discard">Discard</Trans>
              )}
            </button>
          ) : (
            <button
              type="reset"
              className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10"
              disabled={isSubmitting}
            >
              {cancelText || (
                <Trans i18nKey="c.f.simple.button.group.discard">Discard</Trans>
              )}
            </button>
          )}
        </>
      )}
      <button
        type="submit"
        className={classnames({
          btn: true,
          'btn-primary': true,
          'kt-margin-r-10': true,
          'kt-margin-b-10': true,
          'kt-spinner': true,
          'kt-spinner-v2': true,
          'kt-spinner--center': true,
          'kt-spinner--sm': true,
          'kt-spinner--warning': isSubmitting,
        })}
        disabled={isSubmitting || (saveDirty != null && saveDirty === false)}
        onClick={onSubmitFunc}
      >
        <div style={{visibility: isSubmitting ? 'hidden' : 'visible'}}>
          {submitText ||
            (isUpdating ? (
              <Trans i18nKey="c.f.simple.button.group.save.changes">Save</Trans>
            ) : (
              <Trans i18nKey="c.f.simple.button.group.submit">Submit</Trans>
            ))}
        </div>
      </button>
    </>
  );
});
